import { Form } from 'antd';

import { styled } from '@mui/material';

export const FormItemStyled = styled(Form.Item)`
  margin-bottom: 0;

  .ant-form-item-label {
    & > label {
      text-wrap: nowrap;
    }
  }
`;
